export function formatQuoterAmount(value: number | string): string {
  const num = typeof value === "string" ? parseAmountInput(value) : value;
  if (Number.isNaN(num)) return "0,00";
  return num.toLocaleString("es-CO", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function parseAmountInput(value: string): number {
  if (!value || typeof value !== "string") return 0;
  const trimmed = value.trim();
  if (!trimmed) return 0;
  const lastComma = trimmed.lastIndexOf(",");
  const lastDot = trimmed.lastIndexOf(".");
  const lastSep = Math.max(lastComma, lastDot);
  let integerPart: string;
  let decimalPart: string;
  if (lastSep === -1) {
    integerPart = trimmed.replace(/\D/g, "");
    decimalPart = "";
  } else {
    integerPart = trimmed.slice(0, lastSep).replace(/\D/g, "");
    decimalPart = trimmed
      .slice(lastSep + 1)
      .replace(/\D/g, "")
      .slice(0, 2);
  }
  const combined = decimalPart ? `${integerPart}.${decimalPart}` : integerPart || "0";
  const num = parseFloat(combined);
  return Number.isNaN(num) ? 0 : num;
}
